import $ from '@nuskin/nuskinjquery';
import '../domain/couponItem';
import {OrderManager, newShop, CartService} from '@nuskin/ns-shop';
import {RunConfigService, util} from '@nuskin/ns-util';
import {AccountManager} from '@nuskin/ns-account';
import {getCachedConfigField} from '@nuskin/configuration-sdk';


const PromoCodeOffers = function() {
    'use strict';

    let $scope;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {
        initPromoCodeOffers: function(scope) {
            $scope = scope;
            $scope.promoCodeOffers = [];
            $scope.sections.payment.promo = false;
            $scope.addCouponCode = addCouponCode;
            $scope.selectCouponCode = selectCouponCode;
            initCommon();

            populatePromoCodeOffers();

            $scope.$watch('sections.payment.promo', function() {
                if ($scope.contentLoaded) {
                    // ScrollUtil.scrollToPaymentSection();
                }
            });
        },

        // Initializes the basic promo code functionality without
        // populating the table
        initBasicPromoCode: function(scope) {
            $scope = scope;
            $scope.applyShippingCode = applyShippingCode;
            initCommon();
        },

        hasUnAppliedPromoCodes: function hasUnappliedPromoCodes() {
            const productDiscountCode = $scope.order.productDiscountCode || '';
            const productDiscountCodeApplied = $scope.productDiscountCodeApplied || '';
            const shippingDiscountCode = $scope.order.shippingDiscountCode || '';
            const shippingDiscountCodeApplied = $scope.shippingDiscountCodeApplied || '';
            const jpCouponCode = $scope.jpCouponCode || '';

            return (productDiscountCode !== productDiscountCodeApplied)
                || (!!!productDiscountCodeApplied && !!jpCouponCode) ||    // eslint-disable-line
                (shippingDiscountCode !== shippingDiscountCodeApplied);
        },

        setAppliedDiscounts: () => {
            $scope.productDiscountCodeApplied = $scope.order && $scope.order.productDiscountCode;
            $scope.shippingDiscountCodeApplied = $scope.order && $scope.order.shippingDiscountCode;
            setGroupDefaults();
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function initCommon() {
        $scope.removeCouponCode = removeCouponCode;
        $scope.removeShippingCode = removeShippingCode;
        $scope.savePromoCodeClick = savePromoCode;
        $scope.applyPromoCode = applyPromoCode;
        $scope.togglePromoCodeCombo = togglePromoCodeCombo;
        $scope.togglePromoCombo = togglePromoCombo;
        $scope.toggleShippingCombo = toggleShippingCombo;
        $scope.jpCouponCode = '';

        // Expand the promocode sections by default if the config is set
        $scope.showPromoCombo = !!getCachedConfigField('expandPromoCodeDisplay');
        $scope.showShippingCombo = !!getCachedConfigField('expandPromoCodeDisplay');
        $scope.showPromoCodeCombo = !!getCachedConfigField('expandPromoCodeDisplay');
        $scope.canShowPromoApplied = canShowAppliedPromos();
        $scope.canShowPromoGroupApplied = canShowPromoCodeGroup();
        publicMethods.setAppliedDiscounts();
        checkForPersonalOfferPromo();
        setGroupDefaults();
    }

    function applyPromoCode(disabled = false) {
        if (disabled) {
            return;
        }

        $scope.order.shippingDiscountCode = '';
        $scope.simulateOrderWithElement('applyButton1', (successful) => {
            if (!successful) {
                // Clear product discount code so text doesn't remain in the input text box:
                $scope.order.productDiscountCode = '';
                setGroupDefaults();
            }
            OrderManager.saveOrders();
        });
    }

    function applyShippingCode(disabled = false) {
        if (disabled) return;

        $scope.order.productDiscountCode = '';
        $scope.simulateOrderWithElement('applyButton2', (successful) => {
            if (!successful) {
                $scope.order.shippingDiscountCode = '';
                setGroupDefaults();
            }
        });
    }

    function addCouponCode(disabled = false) {
        if (disabled) return;

        $scope.order.productDiscountCode = $scope.jpCouponCode;

        // We need to do a simulate so the user can see the reduction in price.
        $scope.simulateOrder().then(function(hasError) {
            if (hasError) {
                $scope.order.productDiscountCode = '';
                $scope.jpCouponCode = '';
                $scope.productDiscountCodeApplied = '';

                // sync order with local storage
                OrderManager.saveOrders();
            } else {
                $scope.productDiscountCodeApplied = $scope.order.productDiscountCode;
            }
        });
    }
    function removeShippingCode() {
        $scope.order.shippingDiscountCode = '';
        $scope.shippingDiscountCodeApplied = '';

        setGroupDefaults();

        // We need to do a simulate so the user can see the original price.
        $scope.simulateOrder();
    }
    function removeCouponCode() {
        $scope.order.productDiscountCode = '';
        $scope.productDiscountCodeApplied = '';
        $scope.jpCouponCode = '';

        setGroupDefaults();

        // We need to do a simulate so the user can see the original price.
        $scope.simulateOrder();

        // Remove selection of any table rows.
        const promoDetailRows = $('.promo-details');
        if (promoDetailRows && promoDetailRows.length > 0) {
            promoDetailRows.removeClass('highlighted').removeClass('active');
            $('.promo-details input[type="radio"]').removeAttr('checked');
        }
    }
    function savePromoCode(disabled = false) {
        if (disabled) return;

        $scope.sections.payment.promo=false;
    }
    function selectCouponCode(couponCode, event) {
        if ($scope.order.productDiscountCode !== couponCode) {
            $scope.order.productDiscountCode = couponCode;

            // Highlight the selected row
            $('.promo-details').removeClass('highlighted').removeClass('active');
            $(event.currentTarget).addClass('highlighted').addClass('active');

            // Check the radio button.
            $(event.currentTarget).find('input').attr('checked', true);

            // We need to do a simulate so the user can see the reduction in price.
            $scope.simulateOrder().then(function(hasError) {
                if (hasError) {
                    $scope.order.productDiscountCode = '';
                    $scope.jpCouponCode = '';
                    $scope.productDiscountCodeApplied = '';
                    setGroupDefaults();
                } else {
                    $scope.productDiscountCodeApplied = $scope.order.productDiscountCode;
                }
                // sync order with local storage
                OrderManager.saveOrders();
            });
        }
    }

    const setGroupDefaults = () => {
        $scope.showPromoGroup = canShowPromoGroup();
        $scope.showPromoCodeGroup = canShowPromoCodeGroup();
        $scope.showShippingGroup = canShowShippingGroup();
    };

    const canShowAppliedPromos = () => {
        return !$scope.hasEventItems &&
            !($scope.isPitchCart &&
                $scope.personalOffer &&
                $scope.personalOffer.discount &&
                $scope.personalOffer.discount.code &&
                $scope.personalOffer.discount.code !== 'RETAILPRICE') &&
            (
                (!$scope.isGuestCheckout) ||
                (getCachedConfigField('showPitchPromoCode') &&
                    $scope.isPitchCart &&
                    $scope.personalOffer &&
                    (!$scope.personalOffer.discount ||
                        !$scope.personalOffer.discount.code ||
                        $scope.personalOffer.discount.code === 'RETAILPRICE'
                    )
                ) ||
                ($scope.isStorefrontCart &&
                    getCachedConfigField('showStorefrontPromoCode')
                )
            );
    };

    const canShowPromoGroup = () => {
        return !$scope.hasEventItems &&
            (
                (getCachedConfigField('showProductPromoCode') &&
                    !$scope.productDiscountCodeApplied &&
                    !$scope.shippingDiscountCodeApplied &&
                    !$scope.isGuestCheckout
                ) ||
                (getCachedConfigField('showPitchPromoCode') &&
                    $scope.isPitchCart &&
                    $scope.personalOffer &&
                    (!$scope.personalOffer.discount ||
                        !$scope.personalOffer.discount.code ||
                        $scope.personalOffer.discount.code === 'RETAILPRICE'
                    )
                ) ||
                ($scope.isStorefrontCart &&
                    getCachedConfigField('showStorefrontPromoCode')
                )
            );
    };

    const canShowShippingGroup = () => {
        return getCachedConfigField('showShippingPromoCode') &&
            !$scope.productDiscountCodeApplied &&
            !$scope.shippingDiscountCodeApplied;
    };

    const canShowPromoCodeGroup = () => {
        return !$scope.hasEventItems &&
            getCachedConfigField('showPaymentPromoCodeOffers') &&
            !$scope.productDiscountCodeApplied;
    };

    const togglePromoCombo = () => {
        $scope.showPromoCombo = !$scope.showPromoCombo;
    };

    const togglePromoCodeCombo = () => {
        $scope.showPromoCodeCombo = !$scope.showPromoCodeCombo;
    };

    const toggleShippingCombo = () => {
        $scope.showShippingCombo = !$scope.showShippingCombo;
    };

    const checkForPersonalOfferPromo = () => {
        if (AccountManager.isLoggedIn() && AccountManager.isDistributor()) return;
        if ($scope.personalOffer) {
            if (CartService.getCartProperty('isPitchCart') &&
                Object.prototype.hasOwnProperty.call($scope.personalOffer, 'discount') &&
                $scope.personalOffer.discount.code &&
                $scope.personalOffer.discount.code !== 'RETAILPRICE') {
                $scope.order.productDiscountCode = $scope.personalOffer.discount.code;
            }
        }
    };

    function populatePromoCodeOffers() {
        const getAvailableCampaignsForCustomerUrl = util.MobileUtils.checkPath(getCachedConfigField('availableCampaignsForCustomerUrl'), true) +
            '/' + $scope.user.id + '?eid=' + $scope.user.eid + '&country=' + $scope.runConfig.country + '&salesChannel=WEB';

        $.ajax({
            type: 'GET',
            url: getAvailableCampaignsForCustomerUrl,
            headers: {
                'client_id': RunConfigService.getRunConfig().clientId,
                'client_secret': RunConfigService.getRunConfig().clientSecret
            },
            dataType: 'text',
            success: function(data) {
                const listOfCampaigns = $.parseJSON(data);

                if (listOfCampaigns) {
                    const campaignItemList = listOfCampaigns.CampaignItemList;

                    if (campaignItemList) {
                        const locale = $scope.runConfig.language + '_' + $scope.runConfig.country;
                        const getAvailableCouponsForLocaleUrl =
                            util.MobileUtils.checkPath(getCachedConfigField('availableCouponsForLocaleUrl'), true) +
                            '/' + locale + '.service.json';

                        $.ajax({
                            type: 'GET',
                            url: getAvailableCouponsForLocaleUrl,
                            dataType: 'text',
                            success: function(data) {
                                const couponItemList = $.parseJSON(data);

                                if (couponItemList) {
                                    for (let j=0; j < couponItemList.length; j++) {
                                        for (let i = 0; i < campaignItemList.length; i++) {
                                            if (couponItemList[j].campaignId === campaignItemList[i].campaignId) {
                                                // Add a row to the offers table.
                                                $scope.promoCodeOffers.push(new newShop.CouponItem(couponItemList[j]));
                                            }
                                        }
                                    }
                                }
                                $scope.$apply();
                            },
                            error: function(/* xhr*/) {
                                console.log('Failed getting coupons(s) for user.');
                            }
                        });
                    }
                }
            },
            error: function(/* xhr*/) {
                console.log('Failed getting campaign(s) for user.');
            }
        });
    }

    return publicMethods;
}();

export default PromoCodeOffers;
